export default [
  {
    id: 'e6d609b4-1661-4d6a-b35c-63c5b6b31579',
    path: 'sticker-source-management',
    name: 'sticker-source-management',
    meta: { title: '贴源层管理' },
    children: [
      {
        id: '465de5d5-f76f-4bf5-8c3a-582eb8bb2d17',
        path: 'index',
        name: 'index',
        component: () => {
          return import('../views/stickerSourceManagement/index')
        },
        meta: {
          title: '贴源层',
          keepAlive: false,
        },
      },
      {
        id: '00da6504-7194-414b-b57a-1f3d419d94d3',
        path: 'detail',
        name: 'detail',
        component: () => {
          return import('../views/stickerSourceManagement/detail')
        },
        meta: {
          title: '贴源层详情',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/sticker-source-management/index',
        },
      },
    ],
  },
]
